// extracted by mini-css-extract-plugin
export default {"cls1":"yYTM9rqWFPeT0nntmdZB","cls2":"iSzuwYZx3XFcNKyK74i8 yYTM9rqWFPeT0nntmdZB"};